


export const capitalizarPalabra = (palabra) => {
    if( palabra === '' || !isNaN(Number(palabra)) ) return '';
    return palabra.toLowerCase().split(" ").map( string => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }).join(" ");
};




export const generarIDGenerico = () => {
    return (
        Date.now().toString(36) +     
        Math.random().toString(36).substring(2, 6) 
    ).toUpperCase();
};

